export enum SELECT_ADDRESS_EXTERNAL_SERVICES {
  updateAddress = 'updateAddress',
  createAddress = 'createAddress',
  getAddresses = 'getAddresses',
}
